"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosterNoteDTO = void 0;
exports.createRosterNote = createRosterNote;
const model_1 = require("../../model");
const utils_1 = require("../../utils");
const class_transformer_1 = require("class-transformer");
const safe_assign_1 = require("./safe-assign");
class RosterNoteDTO {
    constructor(props) {
        (0, safe_assign_1.safeAssign)(this, props);
    }
}
exports.RosterNoteDTO = RosterNoteDTO;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RosterNoteDTO.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RosterNoteDTO.prototype, "text", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RosterNoteDTO.prototype, "start", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RosterNoteDTO.prototype, "end", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RosterNoteDTO.prototype, "companyId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], RosterNoteDTO.prototype, "color", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RosterNoteDTO.prototype, "filters", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RosterNoteDTO.prototype, "displayAsRosterNote", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RosterNoteDTO.prototype, "vacationPolicy", void 0);
function createRosterNote(values) {
    const defaults = {
        id: undefined,
        text: "",
        start: (0, utils_1.toDateString)(new Date()),
        end: (0, utils_1.toDateString)(new Date()),
        color: null,
        filters: [],
        displayAsRosterNote: true,
        vacationPolicy: model_1.VacationPolicy.AllowAll,
    };
    return new RosterNoteDTO({
        ...defaults,
        ...values,
    });
}
//# sourceMappingURL=roster-note.dto.js.map